import React from 'react';
import { Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { brand } from '../mock';
import heroDrone from '../assets/hero-drone.webp';

const Hero = () => {
  return (
    <section id="top" className="relative min-h-[92vh] flex items-center justify-center overflow-hidden">
      {/* background */}
      <div className="absolute inset-0">
        <img src={heroDrone} alt="Aerial view of a new-build under construction" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#262629]/55" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#262629]/40 via-transparent to-transparent" />
        {/* smooth bottom fade into page background */}
        <div className="absolute bottom-0 left-0 right-0 h-2/3 bg-gradient-to-b from-transparent via-[#262629]/70 to-[#262629]" />
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto mt-28 md:mt-[130px]">
        <h1 className="font-display text-white text-[9vw] leading-[0.95] sm:text-[7.5vw] md:text-[58px] lg:text-[70px]">
          <span className="text-yellow block">Construction</span>
          <span className="text-yellow block">Estimating Service</span>
          <span className="block mt-1 md:mt-2">for UK Builders and Architects</span>
        </h1>
        <p className="text-yellow/95 text-lg md:text-xl max-w-2xl mx-auto mt-5 font-medium">
          Whether you're tendering a build, pricing an extension, or costing a design — we turn plans into numbers you can trust.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-4">
          <a
            href={brand.phoneHref}
            className="inline-flex items-center gap-3 bg-jaw-yellow text-[#262629] font-semibold text-base md:text-lg px-8 py-4 rounded-[10px] hover:bg-[#e8660a] transition-colors shadow-lg shadow-black/20"
          >
            <Phone className="w-5 h-5" strokeWidth={2.5} />
            Call now: {brand.phone}
          </a>
          <Link
            to="/contact"
            className="inline-flex items-center bg-white text-[#262629] font-semibold text-base md:text-lg px-8 py-4 rounded-[10px] hover:bg-white/85 transition-colors shadow-lg shadow-black/20"
          >
            Get in touch
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
